import colors from '../../shared/colors'
import contactPoints from '../../card/contact-points'
import {repeat} from 'quickfield/dist/helpers'

export intro =
	title: 'Get your own customized digital card'
	subtitle: "Here you will be able to create and purchase your very own business & digital cards."
	cta: 'Begin creating your cards'

export confirmation =
	title: 'Final Confirmation'
	subtitle: "Preview and confirm the final looks and details of your cards. Please be advised that after this step you will not be able to make changes."
	cta: 'Next: Checkout'





step1 =
	name: 'lookandfeel'
	title: 'Look & Feel'
	subtitle: 'Custom-tailor your cards to your preference'
	cta: 'Next: Your Details'
	fields: [
		name: 'color'
		label: 'Select your preferred color theme'
		type: 'choice-color'
		choices: colors
		margin: '30px 0 20px'
	]

step2 =
	name: 'details'
	title: 'Your Details'
	subtitle: 'Tell your clients & contacts who you are'
	cta: 'Next: Customize'
	fields: [
		name: 'name'
		label: 'Full Name'
		type: 'text'
		width: '100%'
	,
		name: 'position'
		label: 'Position/Job'
		type: 'text'
		width: '50%'
	,
		name: 'company'
		label: 'Company (optional)'
		type: 'text'
		width: '50%'
		required: false
	,
		name: 'photo'
		label: 'Your Photo'
		type: 'photo'
		width: '100%'
		margin: '20px 0'
	]

step3 =
	name: 'customize'
	title: 'Customize Card'
	subtitle: 'Enter the ways/contact-points people can connect with you through'
	cta: 'Next: Confirmation'

export steps = [step1, step2, step3]
export INDEX_OF_LOOK_AND_FEEL_STEP = 0
export INDEX_OF_DETAILS_STEP = 1
export INDEX_OF_CUSTOMIZE_CARD_STEP = 2
export screenKeys = ['intro', steps.map('name')..., 'confirmation']
export destination = 'requests'